<template>
  <div class="mx-auto w-[330px] md:w-[750px] mt-12 md:mt-24 mb-12">
    <div data-SimpleShopForm="XgE5K">
      <div>
        Prodejní formulář je vytvořen v systému
        <a href="https://www.simpleshop.cz/" target="_blank">SimpleShop.cz</a>.
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

onMounted(() => {

 (function(i, s, o, g, r, a, m){
  i[r] = i[r] || function(){
   (i[r].q = i[r].q || []).push(arguments)
  }, i[r].l = 1 * new Date();
  a = s.createElement(o),
  m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m)
 })(window, document, "script", "https://form.simpleshop.cz/prj/js/SimpleShopService.js", "sss");
 sss("createForm", "XgE5K");
 });
</script>
